import ApisService from './index'
import {
  IPaymentOrderAdd,
  IPaymentOrderUpdate,
} from '../interfaces/paymentOrderInterfaces'
import { handleError } from '../utils/commonUtils'
import * as queryString from 'query-string'

export function createPaymentOrder(data: IPaymentOrderAdd) {
  try {
    return ApisService.post('/thanhtoan/create-thanhtoan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function updatePaymentOrder(data: IPaymentOrderUpdate) {
  try {
    return ApisService.put('/thanhtoan/' + data.id + '/update-thanhtoan', data)
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getDetailPaymentOrder(id: string) {
  try {
    return ApisService.get('/thanhtoan/' + id + '/get-chitiet-thanhtoan')
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function getListPaymentOrder(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisService.get('/thanhtoan/filter-thanhtoan', {
      params: query || {},
    })
  } catch (err) {
    handleError(err)
    throw err
  }
}

export function deletePaymentOrder(id: string) {
  try {
    return ApisService.delete('/thanhtoan/' + id + '/delete-thanhtoan')
  } catch (err) {
    handleError(err)
    throw err
  }
}
